import React from 'react';
import './LoaderButton.css';

import { PageHeader, Table } from 'react-bootstrap';

const ParsDetail = ({ date, location, pars }) => {
  const jsUcfirst = (string) => {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const MakeNamePretty = (item) => {
    return item.split('_').map(jsUcfirst).join(' ');
  };

  function parDetailV2(par_detail) {
    if (par_detail && par_detail.length > 0) {
      return par_detail.map((key) => {
        return (
          <tr>
            <td>{MakeNamePretty(key.itemName)}</td>
            <td>{key.count}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr key={'NO-Data'}>
          <td key={'NO-Data'}> No Data for this date</td>
        </tr>
      );
    }
  }

  return (
    <div>
      <PageHeader>
        {location} <small>{date}</small>
      </PageHeader>

      <Table bordered responsive>
        <thead>
          <tr key={'header-table'}>
            <th key={'Item'}>Item</th>
            <th key={'Need'}>Par</th>
            <th key={'OverCapacityAmount'}>Over Capacity Amount</th>
          </tr>
        </thead>
        <tbody>{parDetailV2(pars)}</tbody>
      </Table>
    </div>
  );
};
export default ParsDetail;
